import type { CSSProperties } from 'react'

// Shared, design-token-aligned inline styles for the zone dialog. Mirrors
// the HTML mockup (`docs/breadstack-settings-fixed.html` lines 3622-3978) and
// stays in sync with `DeliveryProviderDialog`'s sibling visuals.

export const fieldLabelStyle: CSSProperties = {
  display: 'block',
  fontSize: 12,
  fontWeight: 500,
  color: '#7F8C8D',
  marginBottom: 6,
}

export const sectionLabelStyle: CSSProperties = {
  fontSize: 11,
  fontWeight: 600,
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
  color: '#9CA3AF',
  marginBottom: 12,
  display: 'block',
}

export const inputStyle: CSSProperties = {
  width: '100%',
  boxSizing: 'border-box',
  padding: '8px 12px',
  fontSize: 13,
  color: '#2C3E50',
  background: '#fff',
  border: '1px solid #E8ECF0',
  borderRadius: 8,
  outline: 'none',
  fontFamily: 'inherit',
}

// Applied on top of `inputStyle` (or `moneyInputStyle`) when a field has a
// visible validation error. Mirrors the helper-text red (#DC2626) used below.
export const inputErrorStyle: CSSProperties = {
  borderColor: '#DC2626',
  boxShadow: '0 0 0 1px rgba(220, 38, 38, 0.18)',
}

export const errorTextStyle: CSSProperties = {
  fontSize: 11,
  color: '#DC2626',
  margin: '6px 0 0',
  lineHeight: 1.5,
}

export const helpTextStyle: CSSProperties = {
  fontSize: 11,
  color: '#9CA3AF',
  margin: '6px 0 0',
  lineHeight: 1.5,
}

export const moneyPrefixWrapperStyle: CSSProperties = {
  position: 'relative',
}

export const moneyPrefixStyle: CSSProperties = {
  position: 'absolute',
  left: 12,
  top: '50%',
  transform: 'translateY(-50%)',
  fontSize: 13,
  color: '#9CA3AF',
  pointerEvents: 'none',
}

export const moneyInputStyle: CSSProperties = {
  ...inputStyle,
  paddingLeft: 28,
}

// Shared styles for `ZonesOverviewMap` (the read-only all-zones overview).
// Pulled out here (rather than kept local) so the component stays under the
// 200-line convention.

export const zonesOverviewHeaderRowStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: 8,
}

export const zonesOverviewTitleStyle: CSSProperties = {
  fontSize: 12,
  fontWeight: 600,
  color: '#2C3E50',
}

export const zonesOverviewCountStyle: CSSProperties = {
  fontSize: 11,
  color: '#7F8C8D',
}

export const zonesOverviewMapBoxStyle: CSSProperties = {
  width: '100%',
  height: 260,
  borderRadius: 8,
  border: '1px solid #E8ECF0',
  background: '#F0F2F5',
}

export const zonesOverviewOverlayStyle: CSSProperties = {
  position: 'absolute',
  inset: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 12,
  color: '#7F8C8D',
  pointerEvents: 'none',
}

export const zonesOverviewEmptyHintStyle: CSSProperties = {
  position: 'absolute',
  bottom: 10,
  left: 10,
  right: 10,
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  padding: '6px 10px',
  borderRadius: 6,
  background: 'rgba(255,255,255,0.92)',
  border: '1px solid #E8ECF0',
  color: '#7F8C8D',
  fontSize: 11.5,
  pointerEvents: 'none',
}

export const zonesOverviewErrorBoxStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  padding: '12px 16px',
  background: '#FEF2F2',
  border: '1px dashed #FCA5A5',
  borderRadius: 8,
  color: '#B91C1C',
  fontSize: 12,
}
